import { LIST, LIST_FILTERED } from '../actions/types/modulesTypes';

const inicialState = { modules: [], listModules: [], modulesFiltered: [], listModulesFiltered: [] };

export default function (state = inicialState, action) {

  switch (action.type) {

    case LIST:

      return {
        modules: action.result,
        listModules: action.list,
      };

    case LIST_FILTERED:

      return {
        modulesFiltered: action.result,
        listModulesFiltered: action.list,
      };

    default:
      return state;

  }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/moduleReducer.js